<template>
  <div class="content_main">
    <div>
          <a-button type="primary" style="margin: 5px" @click="editAmount"> 修改金额 </a-button>
          <!-- <a-button type="primary" style="margin: 5px" @click="serch"> 数据导出 </a-button> -->
    </div>
      <!-- 搜索区域 -->
      <div class="contaier-top">
          <a-input
            placeholder="项目编号"
            allowClear
            v-model="queryParam.identifier"
            class="a_input_self margin_self"
            @keyup.enter.native="serch"
          />
            <a-input
            placeholder="申请人"
            allowClear
            v-model="queryParam.userName"
            class="a_input_self margin_self"
            @keyup.enter.native="serch"
          />
           <a-select
            placeholder="审批结果"
            allowClear
            class="a_input_self margin_self"
            v-model="queryParam.result"
            default-value="0"
            @keyup.enter.native="serch"
          >
            <a-select-option :value="''">全部</a-select-option>
            <a-select-option v-for="(val, key) in result_apply" :key="key" :value="key">{{ val.txt }} </a-select-option>
          </a-select>
          <a-select
            placeholder="审批状态"
            allowClear
            class="a_input_self margin_self"
            v-model="queryParam.status"
            default-value="0"
            @keyup.enter.native="serch"
          >
            <a-select-option v-for="(val, key) in status_apply_result" :key="key" :value="val.id">{{ val.txt }} </a-select-option>
          </a-select>
           <a-select
            placeholder="修改状态"
            allowClear
            class="a_input_self margin_self"
            v-model="queryParam.upResult"
            default-value="0"
            @keyup.enter.native="serch"
          >
            <a-select-option value="成功">成功  </a-select-option>
            <a-select-option value="失败">失败 </a-select-option>
          </a-select>
          <a-range-picker
            valueFormat="YYYY-MM-DD"
            style="margin-right: 10px; width: 240px"
            allowClear
            :value="dates"
            @change="onChange"
            :placeholder="['申请开始时间', '申请结束时间']"
            @keyup.enter.native="serch"
          />
          <a-button type="primary" style="margin: 5px" @click="serch"> 查询 </a-button>
          <a-button type="primary" ghost @click="result"> 重置 </a-button>
      </div>
      <!-- 表格区域 -->
      <div class="content_main_center_scroll" id="content_main_center_scroll">
         <a-table
          :data-source="projectData"
          bordered
          :loading="loading"
          :scroll="{ y: scroll_y }"
          :pagination="pagination"
          @change="handleTableChange"
        >
          <a-table-column key="index" title="序号" data-index="index" width="70px">
            <template scope="text, record, index">{{ (pagination.current - 1) * 10 + index + 1 }}</template>
          </a-table-column>
          <a-table-column key="identifier" ellipsis="true" title="项目编号" data-index="identifier" />
          <a-table-column key="applyCode" width="250px" ellipsis="true" title="审批编号" data-index="applyCode" />
          <a-table-column key="userName"  ellipsis="true" title="申请人" data-index="userName" />
          <a-table-column key="createTime" ellipsis="true" title="申请时间" data-index="createTime" />
          <a-table-column key="title" width="250px" ellipsis="true" title="标题" data-index="title" />
          <a-table-column key="result" ellipsis="true" title="审批结果" data-index="result" >
            <template scope="text">
              <span class="tag_class" :style="{ background: result_apply[text].color }">
                {{text? result_apply[text].txt : ''}}
              </span>
            </template>
          </a-table-column>
          <a-table-column key="status" ellipsis="true" title="审批状态" data-index="status" >
            <template scope="text">
              <span class="tag_class" :style="{ background: status_apply_result[text].color }">
                {{ text? status_apply_result[text].txt : ''}}
              </span>
            </template>
          </a-table-column>
           <a-table-column key="upResult" ellipsis="true" title="修改状态" data-index="upResult" align="center" >
            <template scope="text">
              <span class="tag_class" :style="{ background:  text === '修改项目金额成功'?'#52C41A':'#FF4D4F' }" v-if="text">
                {{ text === '修改项目金额成功'? '成功' : '失败'}}
              </span>
            </template>
          </a-table-column>
          <a-table-column key="action" title="操作" data-index="action" width="220px">
            <template scope="text,record">
              <a @click="handelAuditone(record)">详情</a>
              <a-divider type="vertical" />
              <a @click="handFlow(record)">历史</a>
              <a-divider type="vertical" />
              <a :disabled="record.status !== 1" @click="cancel([record.procInstId])">撤销</a>
               <a-divider type="vertical" />
              <a :disabled="record.upResult !== '修改项目金额失败'" @click="synchronous(record)">同步</a>
            </template>
          </a-table-column>
        </a-table>
         

      </div>
		<salary ref="salary" @refreshList="serch" ></salary>
		<salaryEditModal ref="salaryEditModal" :audit="false"></salaryEditModal>
		<proc-flow-modal ref="modalflow" @ok="handleOk" />



  </div>
</template>

<script>
import ProcFlowModal from '@/views/activiti/modules/ProcFlowModal.vue' //历史
import salary from '@/views/activiti/modules/salary.vue'
import salaryEditModal from '@/views/activiti/modules/salaryEditModal.vue'
import {	delProcessIns, projectAmountList, updateAgain} from '@/api/activiti'


export default {
  	components: {
		  salary,
      salaryEditModal,
		  ProcFlowModal,
    },
   data() {
    return {
      loading: false,
      scroll_y: 150,
      dates: [],
      queryParam: {
        createTime1: '',
        createTime2: '',
        resule: undefined,
        status: undefined,
        identifier: '',
        userName: '',
        upResult: undefined,
      },
      projectData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
    }
   },
  mounted() {
    this.serch()
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 50
      }, 1000)
    })
  },
   methods: {
     //同步
     synchronous(record) {
       updateAgain({
         id: record.id
       }).then(res => {
         if(res.code == 200) {
           //刷新列表
           this.serch()
           this.$message.success(res.msg)
         }else {
           this.$message.error(res.msg)
         }

       })

     },
      dateFilter(date) {
      if (!date) {
        return date
      }
      const i = date.indexOf(' ')
      date = date.slice(0, i)
      return date
    },
    onChange(date, dateString) {
      this.dates = date
      this.queryParam.createTime1 = date[0]
      this.queryParam.createTime2 = date[1]
    },
    //  查询
     serch() {
       this.loading = true
       projectAmountList({
            pageSize: this.pagination.pageSize,
            pageNum: this.pagination.current,
            status: this.queryParam.status,
            upResult: this.queryParam.upResult,
            result: this.queryParam.result,
            identifier: this.queryParam.identifier,
            userName: this.queryParam.userName,
            createTime1: this.queryParam.createTime1,
            createTime2: this.queryParam.createTime2,
       }).then(res=> {
         if(res.code == 200) {
            this.loading = false
            this.pagination.total = res.total
            this.projectData = res.rows
         }else {
           this.$message.error(res.msg)
         }
       })

     },
     //重置
     result() {
      this.dates = []
       this.queryParam = {
        createTime1: '',
        createTime2: '',
        resule: undefined,
        status: undefined,
        upResult: undefined,
        identifier: '',
        userName: '',
      }
      this.serch()
     },
      //改变分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      // 刷新列表
      this.serch()
    },
    editAmount() {
      this.$nextTick(() => {
				this.$refs.salary.init()
			})
    },
    // 详情
    handelAuditone(record){
      this.$nextTick(() => {
				this.$refs.salaryEditModal.show({
          businessKey: record.buId,
					procInstId: record.procInstId,
					procDefKey: record.procDefKey,
					recordNumber: 1,
					tableId: record.tableId,
					result: record.result

        })
			})
    },
    // 撤销
    cancel(ids) {
				// const idstr = ids.map(r => { return '\'' + r + '\'' }).join('')
				var _this = this
				this.$confirm({
					title: '是否确认撤销?',
					onOk() {
						delProcessIns({
							ids: ids.join(','),
							reason: '主动撤销',
						}).then((res) => {
							if (res.code === 200) {
								_this.$message.success('撤销成功')
								_this.serch()
			                }
						})
					}
				})
			// this.$refs.modalflow.show(obj)
		},
    // 历史
    handFlow(row) {
			var obj = {
				procInstId: row.procInstId,
				procDefKey: row.procDefKey
			}
			this.$refs.modalflow.show(obj)
		},

   }

}
</script>

<style lang="less" scoped>

</style>